/**
  Actiontypes dispatched from actionActions
*/
export enum FeedbackActionType {
  ADD_FEEDBACK_MESSAGE = 'ADD_FEEDBACK_MESSAGE',
  REMOVE_FEEDBACK_MESSAGE = 'REMOVE_FEEDBACK_MESSAGE'
}
